import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import auth from '../../utils/auth';
import SessionExpirationChecker from '../auth/SessionExpirationChecker';
import XeroReauthPrompt from '../xero-reauth/XeroReauthPrompt'; // remove with xero-reauth

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            auth.isAuthenticated() ? (
                <>
                    <SessionExpirationChecker />
                    <XeroReauthPrompt /* remove with xero-reauth */ />
                    <Component {...props} />
                </>
            ) : (
                <Redirect
                    to={{
                        pathname: '/',
                        state: { from: props.location }
                    }}
                />
            )
        }
    />
);

export default PrivateRoute;